import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { PageHeader } from "@/components/admin/common";
import { Field } from "@/components/editor/fields";
import { api, formatErr } from "@/lib/api";

export default function Settings() {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setS(r.data));
  }, []);
  if (!s) return <div className="eyebrow">Caricamento…</div>;
  const save = async () => {
    try {
      const { data } = await api.put("/settings", { brand_name: s.brand_name, privacy_text: s.privacy_text, legal_name: s.legal_name, vat_number: s.vat_number, address: s.address, contact_email: s.contact_email, ga_id: s.ga_id, homepage_public: !!s.homepage_public });
      setS(data);
      toast.success("Impostazioni salvate");
    } catch (e) {
      toast.error(formatErr(e));
    }
  };
  return (
    <div className="max-w-3xl">
      <PageHeader eyebrow="Configurazione" title="Impostazioni"><Button onClick={save} data-testid="settings-save-button">Salva</Button></PageHeader>
      <div className="space-y-6">
        <section className="panel flex items-center justify-between gap-6 p-6">
          <div>
            <div className="eyebrow">Homepage pubblica</div>
            <p className="mt-2 text-sm text-zinc-500">{s.homepage_public ? "La homepage di salvilo.it è visibile a tutti." : "La homepage è nascosta: chi apre salvilo.it vede il login. Card e QR restano raggiungibili."}</p>
          </div>
          <Switch checked={!!s.homepage_public} onCheckedChange={(v) => setS({ ...s, homepage_public: v })} data-testid="settings-homepage-public" />
        </section>
        <section className="panel space-y-4 p-6">
          <div className="eyebrow">Brand</div>
          <Field label="Nome brand nel footer delle card" value={s.brand_name} onChange={(v) => setS({ ...s, brand_name: v })} testId="settings-brand-input" hint={`Mostrato come "Digital card by ${s.brand_name}". Il footer si attiva/disattiva per ogni card dall'editor.`} />
        </section>
        <section className="panel space-y-4 p-6">
          <div className="eyebrow">Dati del titolare (footer, privacy e cookie policy)</div>
          <div className="grid gap-4 sm:grid-cols-2">
            <Field label="Ragione sociale" value={s.legal_name} onChange={(v) => setS({ ...s, legal_name: v })} testId="settings-legal-name" />
            <Field label="P. IVA" value={s.vat_number} onChange={(v) => setS({ ...s, vat_number: v })} testId="settings-vat" />
            <Field label="Sede" value={s.address} onChange={(v) => setS({ ...s, address: v })} testId="settings-address" />
            <Field label="Email privacy" value={s.contact_email} onChange={(v) => setS({ ...s, contact_email: v })} testId="settings-contact-email" />
          </div>
          <Field label="ID Google Analytics 4 (opzionale)" value={s.ga_id} onChange={(v) => setS({ ...s, ga_id: v })} testId="settings-ga-id" placeholder="G-XXXXXXXXXX" hint="Viene caricato solo sulle pagine pubbliche e solo dopo il consenso dei visitatori nel banner cookie." />
        </section>
        <section className="panel space-y-4 p-6">
          <div className="eyebrow">Informazioni privacy aggiuntive (pagina /privacy)</div>
          <Field label="Testo aggiuntivo (opzionale)" area rows={6} value={s.privacy_text} onChange={(v) => setS({ ...s, privacy_text: v })} testId="settings-privacy-input" hint="L'informativa e la cookie policy sono generate con i dati del titolare. Qui puoi aggiungere precisazioni. Fai verificare i testi da un consulente privacy." />
        </section>
        <section className="panel space-y-3 p-6 text-sm text-zinc-600" data-testid="settings-domain-info">
          <div className="eyebrow">Dominio pubblico</div>
          <p>URL base attuale delle card: <span className="font-mono-ui text-zinc-900">{s.public_base_url}</span></p>
          <p>Per usare un dominio tuo (es. <span className="font-mono-ui">https://card.tuodominio.it/c/nome-cognome</span>) collega il dominio al deployment e imposta la variabile <span className="font-mono-ui">PUBLIC_BASE_URL</span> (backend) e <span className="font-mono-ui">REACT_APP_PUBLIC_BASE_URL</span> (frontend), aggiungendo il dominio a <span className="font-mono-ui">CORS_ORIGINS</span>.</p>
          <p className="text-amber-700">Importante: imposta il dominio definitivo prima di stampare i QR. I QR contengono l'URL completo, quindi un cambio di dominio richiederebbe di mantenere attivo anche il dominio precedente.</p>
        </section>
      </div>
    </div>
  );
}
